var map = {
	"./Info.png": 1359,
	"./Prescription.png": 3507,
	"./Tsx.png": 9550,
	"./advice.png": 4903,
	"./blackDown.png": 190,
	"./blackFile.png": 9420,
	"./blackLeft.png": 4797,
	"./blackTdx.png": 3232,
	"./box.png": 8320,
	"./calendar.png": 1865,
	"./check.png": 544,
	"./cross.png": 1587,
	"./dash1.png": 5206,
	"./dash2.png": 5885,
	"./dash3.png": 3380,
	"./diagnosis.png": 3759,
	"./dots.png": 5935,
	"./edit.png": 3799,
	"./eye.png": 1060,
	"./facility1.png": 831,
	"./facility2.png": 7620,
	"./facility3.png": 7869,
	"./file.png": 6849,
	"./followUp.png": 7051,
	"./height.png": 3810,
	"./info2.png": 5037,
	"./link.png": 8875,
	"./mass.png": 3955,
	"./medication.png": 5834,
	"./notes.png": 4460,
	"./notification.png": 7782,
	"./profile.png": 7364,
	"./restart.png": 4538,
	"./search.png": 2671,
	"./settings.png": 6684,
	"./symptom.png": 8658,
	"./t.png": 4247,
	"./temperature.png": 9021,
	"./tick.png": 3868,
	"./video.png": 4570,
	"./vitals.png": 202,
	"./weight.png": 1883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2568;